export default "__VITE_ASSET__ef8bcde7__"